import { StateCreator } from "zustand";
import { produce } from "immer";
import { ReportDetailState } from "../interface";
import { findSection } from "../utils";
import { mergeIncrementalEntries } from "~/helpers/mergeSectionData.helper";

export interface MergeActions {
  /**
   * Merge an incremental "Buscar mais dados" result (task #21220) into the
   * matching already-rendered section, deduped by item identity. No-op
   * (logged, never throws) when the section can't be located — the button
   * that triggers a fetch-more only ever appears on a section already on
   * screen, so this should not happen in practice.
   */
  mergeIncrementalSectionData: (
    sectionTitle: string,
    subsection: string | undefined,
    incomingData: Record<string, any>[],
    identityLabels: readonly string[],
  ) => void;
}

export const createMergeActions: StateCreator<
  ReportDetailState & { actions: any },
  [],
  [],
  MergeActions
> = (set, get) => ({
  mergeIncrementalSectionData: (sectionTitle, subsection, incomingData, identityLabels) => {
    set((state) =>
      produce(state, (draft) => {
        const { reportType, selectedCombinedFilter, sections } = draft.data;
        const section = findSection(sections, sectionTitle, reportType, selectedCombinedFilter, subsection);

        if (!section) {
          console.warn(
            `[mergeIncrementalSectionData] No rendered section matches title="${sectionTitle}" subsection="${subsection}" — skipping merge.`,
          );
          return;
        }

        const { merged, addedCount } = mergeIncrementalEntries(section.data, incomingData, identityLabels);
        console.info(
          `[mergeIncrementalSectionData] title="${sectionTitle}" subsection="${subsection}" ` +
            `existing=${section.data?.length ?? 0} incoming=${incomingData.length} addedCount=${addedCount}`,
        );
        if (addedCount === 0) {
          return;
        }
        section.data = merged;
        section.data_count = merged.length;
      }),
    );

    const actions = get().actions;
    actions.recalculateSectionList();
  },
});
